(function () {
    'use strict';

    angular
        .module(app.modules.scoring.name)
        .factory('strokesGainedBaselineLookup', strokesGainedBaselineLookupFactory);

    var DefaultHandicap = 10;

    strokesGainedBaselineLookupFactory.$inject = ['$cacheFactory', '$q', 'StrokesGained'];
    function strokesGainedBaselineLookupFactory($cacheFactory, $q, StrokesGained) {
        var cache = $cacheFactory('strokesGained'),
            IndexColumns = { indexNegative: 0, index0to5: 6, index6to9: 10, index10to15: 16, index16to20: 21, index21to29: 30, index30Plus: Infinity };

        return strokesGainedBaselineLookup;

        function strokesGainedBaselineLookup(handicap) {
            var result, column;
            column = calculateIndexColumn(handicap);
            result = cache.get(column);
            if (!result) {
                cache.put(column, result = { $resolved: false });
                result.$promise = StrokesGained.query({ $select: 'type,distance,' + column }).$promise
                    .then(createLookup)
                    .finally(setResolved);
            }
            return result;

            function calculateIndexColumn(handicap) {
                handicap = handicap != null ? handicap : DefaultHandicap;
                for (var columnName in IndexColumns)
                    if (handicap < IndexColumns[columnName])
                        return columnName;
            }

            function createLookup(data) {
                return data.reduce(reduce, result);

                function reduce(prev, curr) {
                    var type = curr.type, distance = curr.distance;
                    prev[type + distance] = curr[column];
                    prev[type + 'Max'] = Math.max(isNull(prev[type + 'Max'], -Infinity), distance);
                    prev[type + 'Min'] = Math.min(isNull(prev[type + 'Min'], Infinity), distance);
                    return prev;
                }
            }

            function setResolved() {
                result.$resolved = true;
            }

            function isNull(number, fallback) {
                return number == null ? fallback : number;
            }
        }
    }
})();